import {
  extraWorkedTimeRequestContract,
  ExtraWorkedTimeRequestStatus,
  ExtraWorkedTimeType,
  type GetExtraWorkedTimeRequestsResponse,
} from "@clipboard-health/contract-backend-main";
import { isDefined } from "@clipboard-health/util-ts";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { type UseQueryResult } from "@tanstack/react-query";
import { z } from "zod";

interface ExtraWorkedTimeRequestsByShiftFilters {
  status: ExtraWorkedTimeRequestStatus;
  type?: ExtraWorkedTimeType;
}

const extraWorkedTimeRequestsByShiftParamsSchema = z.object({
  "filter[shiftId]": z.string(),
  "filter[status][]": z.nativeEnum(ExtraWorkedTimeRequestStatus),
  "filter[type][]": z.nativeEnum(ExtraWorkedTimeType).optional(),
});

export function useGetExtraWorkedTimeRequestsByShift(
  shiftId: string,
  filters: ExtraWorkedTimeRequestsByShiftFilters,
  options: UseGetQueryOptions<GetExtraWorkedTimeRequestsResponse> = {}
): UseQueryResult<GetExtraWorkedTimeRequestsResponse> {
  const { status, type } = filters;
  return useGetQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/extra-worked-time-requests`,
    requestSchema: extraWorkedTimeRequestsByShiftParamsSchema,
    responseSchema: extraWorkedTimeRequestContract.getExtraWorkedTimeRequests.responses[200],
    queryParams: {
      "filter[shiftId]": shiftId,
      "filter[status][]": status,
      ...(isDefined(type) ? { "filter[type][]": type } : {}),
    },
    useErrorBoundary: false,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_EXTRA_WORKED_TIME_REQUESTS_FAILURE,
    },
    ...options,
  });
}
